// 1 Canada
// 2 USA

const zipCodesRegex = {
    1: "^[A-Za-z]\\d[A-Za-z] [ -]?\\d[A-Za-z]\\d$",
    //1: "^([^A-Z0-9]*)(?<L1>[ABCEGHJ-NPRSTVXY])(?<D1>[0-9])(?<L2>[ABCEGHJ-NPRSTV-Z])([ -]*)(?<D2>[0-9])(?<L3>[ABCEGHJ-NPRSTV-Z])(?<D3>[0-9])([^A-Z0-9]*)$",
    2: "^[0-9]{5}(-[0-9]{4})?$"
};

const getZipCodeRegex = (countryId) => zipCodesRegex[countryId];

export default getZipCodeRegex;